var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPillsOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_1074",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_1074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0125 10.95L7.05002 4.9875L8.55002 3.4875C8.95002 3.0875 9.40627 2.78125 9.91877 2.56875C10.4313 2.35625 10.9688 2.25 11.5313 2.25C12.7063 2.25 13.7031 2.65938 14.5219 3.47813C15.3406 4.29688 15.75 5.29375 15.75 6.46875C15.75 7.03125 15.6438 7.56875 15.4313 8.08125C15.2188 8.59375 14.9125 9.05 14.5125 9.45L13.0125 10.95ZM14.85 17.025L10.8938 13.0688L9.45002 14.5125C9.05002 14.9125 8.59377 15.2188 8.08127 15.4313C7.56877 15.6438 7.03127 15.75 6.46877 15.75C5.29377 15.75 4.29689 15.3406 3.47814 14.5219C2.65939 13.7031 2.25002 12.7063 2.25002 11.5313C2.25002 10.9688 2.35627 10.4313 2.56877 9.91875C2.78127 9.40625 3.08752 8.95 3.48752 8.55L4.93127 7.10625L1.05002 3.225L2.10002 2.175L15.9 15.975L14.85 17.025Z",
    fill: "#DD705E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPillsOff);
export default __webpack_public_path__ + "static/media/icon-pills-off.868134630f8fc7345f64719e59fdbf56.svg";
export { ForwardRef as ReactComponent };